export default "__VITE_ASSET__PS81YBdT__"